const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/admin/file/list.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { AdminFileListFilterParamSchema } from '@apps/main/features/admin/pages/file/file-list-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/admin/file/list')({
  validateSearch: AdminFileListFilterParamSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});